import React from "react";
import { Select, Tooltip } from "antd";

const { Option } = Select;

const styles = {
  select: {
    width: "100%",
    marginBottom: "7px",
  },
};

function UserSelect(props) {
  const { users, handleChangeUser } = props;

  const getUserFullName = (user) =>
    `${user?.login || ""} ${user?.userInfo?.lastName || ""} ${user?.userInfo?.firstName || ""}`;

  return (
    <Tooltip title="Логин Фамилия Имя">
      <Select
        showSearch
        style={styles.select}
        placeholder="Введите пользователя"
        onChange={handleChangeUser}
        optionFilterProp="children"
      >
        {users.map((item) => (
          <Option key={item.id} value={item.id}>
            {getUserFullName(item)}
          </Option>
        ))}
      </Select>
    </Tooltip>
  );
}

export default UserSelect;
